import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";

const baseEndpointUri = "manager/company/white-label";

class WhiteLabelEndpoint {
  constructor(
    public documents: WhiteLabelDocumentsEndpoint = new WhiteLabelDocumentsEndpoint()
  ) {}
  public view() {
    return $api.get(baseEndpointUri);
  }
  public update(form: object): Promise<AxiosResponse> {
    return $api.put(baseEndpointUri, form as AxiosRequestConfig);
  }

  public uploadImage(column: string, image: File) {
    const formData = new FormData();
    formData.append("column", column);
    formData.append("image", image);

    return $api.direct({
      url: `${baseEndpointUri}/upload-image`,
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}

class WhiteLabelDocumentsEndpoint {
  public list() {
    return $api.get(`${baseEndpointUri}/documents`);
  }
  public update(form: object): Promise<AxiosResponse> {
    return $api.put(`${baseEndpointUri}/documents`, form as AxiosRequestConfig);
  }

  public uploadImage(document_type: string, column: string, image: File) {
    const formData = new FormData();
    formData.append("document_type", document_type);
    formData.append("column", column);
    formData.append("image", image);

    return $api.direct({
      url: `${baseEndpointUri}/documents/upload-image`,
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}

export default WhiteLabelEndpoint;
